import React from 'react';
import { useCategorias } from '../context/CategoriasContext';

export default function CategoriasGrid({ onSeleccionar, onAdministrar }) {
  const { categorias, cargando, error, recargar } = useCategorias();

  return (
    <div className="k-page">
      <div className="k-page-head">
        <h2 className="k-page-title">Categorías</h2>
        <button onClick={onAdministrar} className="k-btn-soft">
          ⚙️ Administrar
        </button>
      </div>

      {cargando && (
        <div style={{ textAlign: 'center', padding: '48px', color: '#6B7280' }}>
          <div style={{ fontSize: '32px', marginBottom: '8px' }}>⏳</div>
          <p style={{ margin: 0, fontWeight: 600 }}>Cargando categorías...</p>
        </div>
      )}

      {!cargando && error && (
        <div style={{ textAlign: 'center', padding: '32px', backgroundColor: '#FEE2E2', borderRadius: '12px', border: '1px solid #FCA5A5' }}>
          <p style={{ margin: '0 0 12px', color: '#991B1B', fontWeight: 600 }}>⚠️ {error}</p>
          <button onClick={recargar} style={{ backgroundColor: '#DC2626', color: 'white', border: 'none', borderRadius: '8px', padding: '8px 20px', fontWeight: 'bold', cursor: 'pointer' }}>
            Reintentar
          </button>
        </div>
      )}

      {!cargando && !error && (
        <div className="k-cats">
          {categorias.map((cat) => (
            <div key={cat.id} onClick={() => onSeleccionar(cat.nombre)} className="k-cat">
              <span className="k-cat-ic" style={{ backgroundColor: cat.color, border: `1px solid ${cat.borde}` }}>{cat.icono}</span>
              <b>{cat.nombre}</b>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
